<template>
  <!-- Navbar -->
  <nav id="topBar" class="absolute top-0 left-0 w-full z-9 bg-white  md:flex-row md:flex-no-wrap md:justify-start flex items-center p-2 " style="z-index: 500;">
    <div class="w-full h-12 relative flex items-center gap-4 flex-0 px-4 z-49">

      <button @click="actionSidebar" class="focus:outline-none mat-focus-indicator mat-icon-button mat-button-base text-primary-600">
        <span class="flex items-center justify-center">
          <svg class="w-8 h-8" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" height="24" width="24" preserveAspectRatio="xMidYMid meet" focusable="false">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" fill="currentColor"></path>
          </svg>
        </span>

        <span matripple="" class="mat-ripple mat-button-ripple mat-button-ripple-round"></span>
        
        <span class="mat-button-focus-overlay"></span>
      </button>

      <a class="flex items-center gap-2 text-primary-600" href="/" v-if="typeUser != 'TeleConsultant'">
        <svg class="inline-block h-6  w-6 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path fill-rule="evenodd" d="M3.889 3h6.222a.9.9 0 0 1 .889.91v8.18a.9.9 0 0 1-.889.91H3.89A.9.9 0 0 1 3 12.09V3.91A.9.9 0 0 1 3.889 3zM3.889 15h6.222c.491 0 .889.384.889.857v4.286c0 .473-.398.857-.889.857H3.89C3.398 21 3 20.616 3 20.143v-4.286c0-.473.398-.857.889-.857zM13.889 11h6.222a.9.9 0 0 1 .889.91v8.18a.9.9 0 0 1-.889.91H13.89a.9.9 0 0 1-.889-.91v-8.18a.9.9 0 0 1 .889-.91zM13.889 3h6.222c.491 0 .889.384.889.857v4.286c0 .473-.398.857-.889.857H13.89C13.398 9 13 8.616 13 8.143V3.857c0-.473.398-.857.889-.857z"></path>
        </svg>
        {{ $t('dashboard') }}
      </a>
    
      <div class="flex items-center ml-auto">
        <ul class="flex-row list-none items-center flex justify-center gap-3">
          <Language />
          <Country />
          <user-dropdown />
        </ul>
      </div>

    </div>
  </nav>

</template>

<script>
import UserDropdown from '@/components/Dropdowns/UserDropdown.vue';
import NotificationDropdown from '@/components/Dropdowns/NotificationDropdown.vue';
import Language from '@//components/Dropdowns/Language.vue';
import Country from '@//components/Dropdowns/Country.vue';
export default {
  components: {
    UserDropdown,
    NotificationDropdown,
    Language,
    Country,
  },
  props: {
    typeUser: { type: String },
  },
  data() {
    return {
      topBar: 'bg-white',
    };
  },
  methods: {
    actionSidebar() {
      this.$store.dispatch('actionSidebar');
    },
  },
};
</script>
<style>
#topBar {
  background: white none repeat scroll 0% 0%;
  color: #fff;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
}
.z-9 {
  z-index: 9;
}
</style>
